<template>
  <div class="header">
    <img
      class="topImg"
      src="../../assets/imgs/apply/topImg.png"
      alt=""
    >
    <div class="content">
      <img
        src="../../assets/imgs/apply/基本信息.png"
        alt=""
      >
    </div>

    <div class="btn">
      <el-button
        type="primary"
        @click="apply"
        style="width:312px;margin-bottom:20px;"
      >立即申请</el-button>
    </div>

  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    apply () {
      window.open('https://wbank.suzhoubank.com/WechatMbank/index.html#/activity/zxd/zxdApply/twoCompanyInfo?path=activity%2Fzxd%2FzxdApply%2FtwoCompanyInfo', '_blank')
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .topImg {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
  .content {
    margin-top: -1px;
    width: 1280px;
    margin: auto;
    font-size: 0px;

    img {
      width: 100%;
      vertical-align: top;
    }
  }
  .btn {
    margin-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style> 